@if (data(); as msg) {
    Added <program-item [program]="msg.program" />
}
 